const Icon404 = () => (
  <svg width="262" height="166" viewBox="0 0 262 166" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M89.6797 101.516V120.496H1.58008L0.404297 105.799L51.3828 24.9221H70.6152L49.7871 59.7756L24.4238 101.516H89.6797ZM75.8223 24.9221V147.203H51.6348V24.9221H75.8223Z"
      fill="black"
      fillOpacity="0.87"
    />
    <path
      d="M261.68 101.516V120.496H173.58L172.404 105.799L223.383 24.9221H242.615L221.787 59.7756L196.424 101.516H261.68ZM247.822 24.9221V147.203H223.635V24.9221H247.822Z"
      fill="black"
      fillOpacity="0.87"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.3103 143.116C98.4186 142.359 97.8986 142.168 97.8679 141.39C97.8536 141.024 97.997 140.682 98.1521 140.42C98.4334 139.951 98.5913 139.694 98.619 138.972C98.4143 138.167 98.7741 137.675 99.5625 137.501C100.129 137.375 99.7145 137.377 100.11 136.897C100.279 136.692 100.545 136.487 100.931 136.487C101.702 136.488 101.477 136.558 102.117 136.22C102.384 136.078 102.63 136.097 102.854 136.172C103.462 136.378 103.489 136.102 104.018 136.227C104.662 136.377 104.377 136.609 105.102 136.693C105.341 136.721 105.577 136.799 105.76 137.047C106.191 137.628 106.018 137.468 106.715 137.8C107.063 137.967 107.214 138.267 107.278 138.525C107.428 139.128 107.186 138.819 107.584 139.246C107.854 139.538 107.891 139.88 107.769 140.463C107.711 140.744 108.088 140.713 107.873 141.277C107.907 141.586 107.97 141.912 107.793 142.133C107.668 142.289 107.579 142.371 107.516 142.482C107.518 142.503 107.52 142.525 107.522 142.548C107.549 142.85 107.531 143.221 107.359 143.545C106.681 143.909 106.392 144.346 106.392 144.346L106.203 144.947C105.323 145.503 105.469 145.761 104.719 145.779C103.782 146.68 103.091 146.094 102.73 146.012C102.565 145.974 102.446 145.997 102.303 146.036C101.77 146.181 101.471 146.045 101.05 145.675C100.821 145.475 100.728 145.484 100.832 145.179C100.974 144.766 99.8642 144.614 99.8282 144.406C99.7708 144.076 99.9996 143.976 99.5486 143.95C99.1925 143.928 98.6535 143.87 98.5703 143.515C98.5139 143.275 98.4814 143.147 98.3103 143.116Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.8034 143.721C91.8034 143.721 91.4923 143.503 91.4703 143.022C91.46 142.798 91.5486 142.59 91.6447 142.431C91.8191 142.145 91.6181 141.851 91.9318 141.547C91.801 141.054 92.0243 140.755 92.517 140.651C92.8712 140.576 92.6116 140.576 92.8571 140.284C92.9622 140.159 93.1279 140.035 93.3694 140.036C93.8521 140.039 93.7115 140.081 94.1104 139.877C94.2774 139.791 94.4315 139.804 94.5716 139.85C94.9528 139.978 94.9683 139.81 95.3002 139.888C95.7031 139.982 95.5256 140.122 95.9797 140.176C96.1293 140.194 96.2771 140.243 96.3928 140.395C96.6643 140.752 96.5555 140.653 96.9923 140.859C97.2107 140.962 97.3065 141.145 97.3473 141.303C97.4431 141.672 97.2909 141.483 97.5409 141.745C97.7113 141.924 97.7355 142.134 97.6613 142.49C97.6256 142.661 97.8618 142.644 97.7287 142.987C97.7516 143.176 97.792 143.376 97.6817 143.511C97.4552 143.787 97.5841 144.059 97.4154 144.372C97.1881 144.796 96.8133 144.858 96.8133 144.858L96.6971 145.225C96.5808 145.592 96.2406 145.72 95.7714 145.728C95.1896 146.275 94.8369 145.726 94.2611 145.877C93.928 145.964 93.7402 145.88 93.4757 145.652C93.263 145.47 93.432 145.262 93.1517 145.232C92.9621 145.212 92.7413 145.06 92.707 144.873C92.6352 144.481 92.2689 144.714 92.26 144.319C92.2522 143.951 91.7263 144.268 91.8034 143.721Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.023 106.498L187.432 110.686C187.432 110.686 188.683 117.924 182.401 124.776C179.471 127.971 175.407 129.6 171.915 130.453C171.352 130.588 170.834 130.714 170.356 130.821C166.786 135.686 163.959 138.707 155.894 138.565C150.927 147.075 143.776 148.098 135.634 142.766C129.777 138.933 133.311 142.496 125.967 143.108C122.823 143.371 118.859 142.796 115.587 139.466C109.046 132.81 111.537 134.167 103.298 131.486C99.8502 130.363 97.9172 128.085 96.648 125.527C93.1971 118.564 90.6803 120.647 87.2227 115.035C83.0226 108.227 87.3668 108.744 81.9166 101.783C80.1212 99.4901 78.7713 96.8026 79.2762 93.1456C80.4641 84.5596 80.5977 87.3934 77.4595 78.606C75.8913 74.2086 77.1034 70.3908 78.7124 67.6773C82.4646 61.3323 81.9445 65.9991 82.1299 58.9963C82.2611 54.2205 84.7987 51.0344 90.6869 47.1987C93.5243 45.3509 90.0664 42.3487 96.5903 39.4869C98.8661 36.5995 101.055 33.3175 104.401 32.9979C106.759 32.7709 108.2 32.8496 109.657 32.4628C109.816 32.2668 109.98 32.0679 110.151 31.8586C112.44 29.0846 115.679 26.1386 119.835 24.9012C128.742 22.2398 134.708 26.524 134.708 26.524L141.323 23.1115C147.938 19.699 154.323 22.6246 160.837 28.9387C176.297 29.4625 177.273 40.3354 179.653 44.1347C180.737 45.8663 181.941 46.7026 183.473 47.6026C189.206 50.9815 190.609 54.7063 191.098 61.4342C191.213 62.9905 191.054 64.5269 191.787 65.8308C191.146 66.3222 190.201 66.7989 188.812 67.4696C184.552 69.5227 187.888 69.2798 189.76 71.6021C191.626 73.9274 189.006 75.9788 188.768 77.5642C188.53 79.1497 193.164 79.3311 190.896 82.5988C188.627 85.8664 185.857 84.7292 189.463 88.8378C193.064 92.9492 192.382 93.1711 189.398 96.2782C186.41 99.3807 196.373 97.2499 194.145 100.909C192.625 103.407 191.834 104.774 193.028 106.507L193.023 106.498Z"
      fill="white"
      stroke="black"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M98.5294 72.0998C91.5383 80.7365 84.4834 62.2259 91.2114 61.8397C98.8742 61.4001 102.14 64.5159 98.5294 72.0998Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.339 115.691C111.848 116.706 114.549 122.176 112.549 127.11C110.553 132.04 101.818 128.291 100.657 125.825C99.5018 123.355 98.0793 115.475 108.335 115.694L108.339 115.691Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M142.657 71.5339C142.395 66.0474 144.204 61.9879 149.486 64.3645C154.768 66.7412 152.92 73.9523 149.233 75.5254C145.542 77.0998 142.611 74.5524 142.657 71.5339Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M184.558 101.431C189.415 100.903 193.636 104.427 187.348 107.359C181.056 110.294 180.164 103.465 184.558 101.431Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M139.965 124.478C147.42 126.265 152.166 133.218 142.798 136.913C133.429 140.608 132.232 126.167 139.965 124.478Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.225 115.656C146.709 110.487 153.705 96.1387 161.778 103.835C173.306 114.818 154.901 116.987 153.225 115.656Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M174.863 70.031C181.491 71.4708 181.996 77.3231 178.35 80.1838C174.704 83.0444 168.809 80.6137 167.422 78.9113C166.042 77.2105 168.478 67.7915 174.859 70.0339L174.863 70.031Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.333 43.1648C125.837 53.7118 114.978 43.7382 119.809 39.5926C125.312 34.8731 128.665 35.3523 128.333 43.1648Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.453 45.1842C172.993 54.4997 158.255 54.8829 158.844 48.5445C159.516 41.3264 162.259 39.3388 167.453 45.1842Z"
      fill="#1F4462"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.39 91.768C117.334 85.4644 125.864 80.1349 127.208 88.3769C128.553 96.6189 116.307 97.5313 115.39 91.768Z"
      fill="#1F4462"
    />
  </svg>
);

export { Icon404 };
